import type { StatusBadgeColor } from './complianceFormatters';
import { appLocale } from './appLocale';

/**
 * Helpers for the D3 per-client communications history view. Maps notification
 * delivery status to a Fluent badge color and formats the audit-row timestamp.
 * Pulled out of `StateTaxClientDetailPage.tsx` for unit coverage.
 */

/**
 * Notification delivery status → Fluent badge color. Anything outside the
 * known set ("sent" / "failed" / "pending") falls back to "subtle" so a new
 * status string (e.g. "delivered") doesn't visually hijack the timeline.
 */
export function communicationStatusColor(status: string): StatusBadgeColor {
  const s = status.toLowerCase();
  if (s === 'sent') return 'success';
  if (s === 'failed') return 'danger';
  if (s === 'pending') return 'warning';
  return 'subtle';
}

/**
 * ISO timestamp → locale "Apr 19, 2026, 9:00 AM"–style string for the
 * communications history feed. Falls back to the raw ISO if Date.parse
 * fails so the UI never shows "Invalid Date".
 */
export function formatCommunicationTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(appLocale(), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
